module.exports = __webpack_public_path__ + "img/product_58.1949dc5.svg";